/**
 * @function AccordionPage
 * @description A React component that renders an accordion interface using the data from the Sanity CMS. It displays a list of collapsible sections, with the active section's content revealed. It accepts the accordion items from the Sanity CMS and maintains the active state using React's useState hook. The arrows indicate the state of each section, toggling between the expanded and collapsed views.
 * @param {Object} props - The props object for the component.
 * @param {Object} props.sanity - The data object from Sanity CMS containing the accordion items.
 * @param {Object[]} props.sanity.accordion - The array of accordion items, each containing the unique key, title, and description.
 * @example
 *   <AccordionPage sanity={{accordion: accordionData}} />
 * @returns {ReactElement} Returns the accordion interface with collapsible sections displaying title and description, and images indicating the state of each section.
 */
import {Image} from '@shopify/hydrogen';
import React, {useState} from 'react';
import arrowDown from '../assets/image/arrow-collapse-p.svg';
import arrowUp from '../assets/image/arrow-collapse-w.svg';

import 'rc-slider/assets/index.css';

export default function AccordionPage({sanity}) {
  const [isActive, setActive] = useState('');
  const [isActiveValue, setActiveValue] = useState([]);
  const items = sanity.accordion;
  return (
    <>
      <div className=" border-b mt-3">
        <div>
          {items.map((item) => {
            return (
              <>
                <div
                  onClick={() => {
                    setActive(item._key);
                  }}
                  className={`font-semibold text-lg py-3 cursor-pointer p-2 border-t-2 border-gray-75 ${
                    isActive == item._key ? ' bg-purple-120 text-white ' : ''
                  }`}
                >
                  <div className="max-w-3xl mx-auto justify-between flex-row w-full flex items-center">
                    <div>{item.title}</div>
                    <div> 
                    {isActive != item._key ? 
                    <Image src={arrowDown} width={20} height={20} /> :
                    <Image src={arrowUp} width={20} height={20} />
                    }
                    </div>
                  </div>
                </div>

                {isActive == item._key && (
                  <div className=" text-lg cursor-pointer p-2 border-gray-75  bg-blue-40">
                    <div className="max-w-3xl mx-auto text-sm py-5">
                      {item.description}
                    </div>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    </>
  );
}
